import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { CardContent, Grid, InputAdornment, Box, Fab, Button, Card, Container, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography, Popover, FormHelperText } from '@mui/material'
import { fetchBundles, getqualitymaterialcode, getqualityinspection, getgrievancedetails, getIssueNo, getpitinventorydetails, fetchinspectordetails, fetchqualitydetails, fetchequipmentdetailsdetails, saveinspectiondetails } from './qualityApi';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Chip from '@mui/material/Chip';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { Add as AddIcon, Search as SearchIcon } from '@mui/icons-material';
import moment from "moment";
import { fDate } from '../../common/common-sidebar/utils/formatTime';
import { VALIDATION, capitalizeFunction, openTextFieldMaxLength } from '../../common/commonValidations';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { SubmitIcon } from '../../common/icons';

function AddInspectionPage() {
    const navigate = useNavigate();
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const [details, setDetails] = useState({
        type: 'Issue',
        materialCode: '',
        inspectionFor: '',
        inspectorName: '',
        surprise: false,
        surpriseString: '',
        quaParam: '',
        equipmentdetails: '',
        inspectDescription: '',
        inspectorEmail: '',
        inspectorMobileNo: '',
        selectedURN: '',
        grievenceNumber: ''
    });
    const [grevianceDetails, setGreievanceDetails] = useState({
        bundleId: '',
        qualityParameter: '',
        materialCode: '',
        weightactualQuantity: '',
        mositureactualQuantity: '',
        grievenceNumber: ''
    });
    const [errorMessage, setErrorMessage] = useState({
        errinspectionFor: '',
        errSelectedUrn: '',
        errSurprise: '',
        errequipmentused: '',
        errdescription: ''
    });
    const [allissuedetails, setAllIssueDetails] = useState();
    const [allGrievanceDetails, setAllGrievanceDetails] = useState();
    const [allmaterialcode, setAllMaterialCode] = useState([]);
    const [allinspectiondetails, setAllInspectionDetails] = useState([]);
    const [inspectorDetails, setInspectorDetails] = useState([]);
    const [qualityParamDetails, setQualityParamDetails] = useState([]);
    const [multiselectEquipment, setMultiSelectEquipment] = useState([]);
    const [allequipmentdetails, setAllEquipmentDetails] = useState([]);
    const [createWorkOrderReqst, setCreateWorkOrderReqst] = useState([]);
    const [finalinspectionsubmission, setFinalInspectionSubmission] = useState();
    const [datevalue, setDateValue] = useState();
    const [quaParamMulti, setquaParamMulti] = useState([]);
    const [bundleIdEntity, setBundleIdEntity] = useState([]);
    const [selectedLleIsData, setSelectedLleIsData] = React.useState([]);
    const [submit, setSubmit] = useState(false);
    const [showIssueUrn, setShowIssueUrn] = useState(true);
    const [selectedRowNo, setSelectedRowNo] = useState();
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);

    const radioChange = (selectedTicketNumber, rowval) => {
        setSelectedRowNo(selectedTicketNumber);
        setDetails({ ...details, grievenceNumber: rowval?.ticketNumber })
        setGreievanceDetails();
    }
    const handleDateChange = (e) => {
        setDateValue(e.format("YYYY-MM-DD"));
    }
    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "type") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            setCreateWorkOrderReqst([]);
            setSelectedRowNo([]);
            setSelectedLleIsData([])
            e.target.value === 'Issue' ? setShowIssueUrn(true) : setShowIssueUrn(false)
        }
        if (e.target.name === "inspectorName") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            let result_details = e.target?.value?.split("*")
            setDetails({ ...details, inspectorName: result_details[0], inspectorEmail: result_details[1], inspectorMobileNo: result_details[2] })
        }
        if (e.target.name === "surpriseString") {
            // setDetails({ ...details, [e.target.name]: e.target.value })
            (e.target.value === 'Yes') ? setDetails({ ...details, surprise: true, surpriseString: 'Yes' }) : setDetails({ ...details, surprise: false, surpriseString: 'No' })
            setErrorMessage({ ...errorMessage, errSurprise: "" });
        }

        if (e.target.name === "inspectDescription") {
            setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) })
            setErrorMessage({ ...errorMessage, errdescription: "" });
        }
    }
    const handleMultiEquipment = (e) => {
        const { target: { value }, } = e;
        setMultiSelectEquipment(
            typeof value === 'string' ? value.split(',') : value,
        );
        setErrorMessage({ ...errorMessage, errequipmentused: "" });
    }
    const handleBundleId = (e) => {
        setGreievanceDetails({ ...grevianceDetails, bundleId: e.target.value })
    }
    const onBundleSearch = () => {
        fetchBundles(grevianceDetails?.bundleId, grevianceDetails, setGreievanceDetails)
    }
    useEffect(() => {
        getqualitymaterialcode(setAllMaterialCode);
        getqualityinspection(setAllInspectionDetails);
        fetchinspectordetails(setInspectorDetails);
        fetchequipmentdetailsdetails(setAllEquipmentDetails);
        fetchqualitydetails(setQualityParamDetails);
    }, []);
    useEffect(() => {
        if (details?.type === 'Issue') {
            getIssueNo(setAllIssueDetails);

        }
        if (details?.type === 'Grievance') {
            setDetails({ ...details, selectedURN: '' })
            getgrievancedetails(setAllGrievanceDetails);
        }
    }, [details?.type]);
    useEffect(() => {
        if (allissuedetails) {
            const tempArr = []
            const findUrn = allissuedetails?.find(item => (item?.status == "Rejected") || ((item?.inspectionWorkOrderId == null) && (item?.status == "Open")))
            setDetails({ ...details, selectedURN: findUrn?.measurementLocation })
            allissuedetails?.map((item, index) => {
                const qualityWorkLogEntity = []
                qualityWorkLogEntity.push(
                    {
                        "triggeringReason": item?.issueNumber,
                        "qualityParameter": item?.qualityParameter,
                        "materialCode": item?.materialCode,
                        "actualQuantity": item?.measured_quantity,
                        "recordedQuantity": item?.recordedQuantity ? item?.recordedQuantity : null,
                    }
                )
                tempArr.push({
                    "issueNumber": item?.issueNumber,
                    "bundleId": item?.lotNumber ? item?.lotNumber : item?.consignmentId,
                    "qualityWorkLogEntity": qualityWorkLogEntity,

                })
            })
            setBundleIdEntity(tempArr)
        }
    }, [allissuedetails]);
    useEffect(() => {
        if (grevianceDetails) {
            setBundleIdEntity([])
            const tempArr = []
            const qualityWorkLogEntity = []
            qualityWorkLogEntity.push(
                {
                    "triggeringReason": selectedRowNo,
                    "qualityParameter": "Weight",
                    "actualQuantity": grevianceDetails?.weightactualQuantity,
                    "materialCode": grevianceDetails?.materialCode
                },
                {
                    "triggeringReason": selectedRowNo,
                    "qualityParameter": "AvgMoisture",
                    "actualQuantity": grevianceDetails?.mositureactualQuantity,
                    "materialCode": grevianceDetails?.materialCode
                }
            )
            tempArr.push({
                "bundleId": grevianceDetails?.bundleId,
                "qualityWorkLogEntity": qualityWorkLogEntity,

            })
            setBundleIdEntity(tempArr)

        }
    }, [grevianceDetails]);
    const onClickChecked = (value) => {
        let filteredArray = bundleIdEntity.filter(function (itm) {
            return value.indexOf(itm?.issueNumber) > -1;
        });
        setSelectedLleIsData(filteredArray)
    }

    const onConfirmSubmit = () => {
        handleLogModalCloseSubmit();
        const finalbundlelst = selectedLleIsData?.map((({ issueNumber, ...rest }) => rest))
        createWorkOrderReqst.push({
            "inspectionOrderId": '',
            "inspectDescription": details?.inspectDescription,
            "categoryOfInspection": details?.type,
            "requesterName": '',
            "inspectorName": details?.inspectorName,
            "inspectorEmail": details?.inspectorEmail,
            "inspectorContactNo": details?.inspectorMobileNo,
            "materialCode": '',
            "inspectionEquipmentUsed": multiselectEquipment?.map(i => i).join(', '),
            "status": 'Open',
            "measuredQuantity": '',
            "stakeholderUrn": details?.selectedURN,
            "dateOfInspection": datevalue ? datevalue : moment().format("YYYY-MM-DD"),
            "inspectionLocationType": details?.type === "Issue" ? allissuedetails.find((item) => item.measurementLocation === details?.selectedURN).locationType : details.inspectionFor,
            "inspectionStorageLocation": details?.selectedURN,
            "lotNumber": '',
            "triggeringReason": '',
            "grievenceNumber": details?.grievenceNumber ? details?.grievenceNumber : '',
            "surprise": details?.surprise,
            "bundleIdEntity": finalbundlelst?.length > 0 ? finalbundlelst : bundleIdEntity
        })
        saveinspectiondetails(createWorkOrderReqst, setFinalInspectionSubmission, navigate);
    }

    const finalSubmit = (e) => {
        setSubmit(true)
        if (!details.surpriseString) {
            setErrorMessage({ ...errorMessage, errSurprise: "Select Surprise" });
        }
        else if (multiselectEquipment?.length < 1) {
            setErrorMessage({ ...errorMessage, errequipmentused: "Select Equipment Details" });
        }
        else if (!details.inspectDescription) {
            setErrorMessage({ ...errorMessage, errdescription: "Add Inspection Description" });
        }
        else if ((selectedLleIsData?.length < 1) && (details?.type === 'Issue')) {
            toast.error('Please Select Minimum One  Details')
        }
        else if ((!grevianceDetails.bundleId) && (details.type === 'Grievance')) {
            toast.error('Please Select Minimum One  Details')
        }
        else {
            handleLogModalOpenSubmit();
        }
    }
    const issueColumns = [
        { field: 'issueNumber', headerName: 'Issue No', width: 100 },
        { field: 'lotNumber', headerName: 'Bundle ID', width: 250 },
        { field: 'consignmentId', headerName: 'Consignment Id', width: 250 },
        { field: 'measurementLocation', headerName: 'URN', width: 150 },
        { field: 'qualityParameter', headerName: 'Quality Parameter', width: 150, },
        { field: 'recordedQuantity', headerName: 'Recorded Quantity', width: 150, },
        { field: 'measured_quantity', headerName: 'Actual Quantity', width: 150, },
        { field: 'toleranceLimit', headerName: 'Tolerance Limit', width: 120 },
        { field: 'materialCode', headerName: 'Material Code', width: 120 },
        { field: 'createdBy', headerName: 'Issue Raised By', width: 120 },
        {
            field: 'createdOn', headerName: 'Issue Date', width: 120,
            renderCell: (params) => (<div>{fDate(params?.value, 'dd/MM/yyyy')}</div>
            ),
        },
    ]
    const grievanceColumns = [
        {
            field: 'radio', headerName: '', width: 10,
            renderCell: (params) => (<input type="radio" name="bundleId"
                onChange={() => radioChange(params?.row?.ticketNumber, params?.row)}
            />
            ),
        },
        { field: 'ticketNumber', headerName: 'Grievance No', width: 120 },
        { field: 'grievanceDescription', headerName: 'Grievance Description', width: 250 },
        {
            field: 'bundleId', headerName: 'Bundle Id/Consignment No', width: 280,
            renderCell: (params) => {
                const handleKeyDown = (event) => {
                    if (event.key === ' ') {
                        event.stopPropagation(); // Stops event bubbling to prevent row selection
                    }
                };
                return (
                    params?.row?.ticketNumber === selectedRowNo ? <TextField fullWidth
                        label="Bundle Id/ Consignment No"
                        name="comments"
                        size="small"
                        onChange={(e) => handleBundleId(e)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon onClick={() => onBundleSearch()} />
                                </InputAdornment>
                            ),
                        }}
                        onKeyDown={handleKeyDown}
                        value={details?.bundleId}
                        sx={{ width: "100%" }}
                    /> : <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'qualityWorkLogEntity', headerName: 'Quality Parameter', width: 150,
            renderCell: (params) => {
                return (
                    params?.row?.ticketNumber === selectedRowNo ?
                        <Typography>{grevianceDetails?.weightactualQuantity ? 'Weight' : ''} {grevianceDetails?.weightactualQuantity ? ',' : ''}{grevianceDetails?.mositureactualQuantity ? 'AvgMoisture' : ''}</Typography>
                        : ''
                )
            }
        },
        {
            field: 'materialCode', headerName: 'Material Code', width: 120,
            renderCell: (params) => {
                return (params?.row?.ticketNumber === selectedRowNo ? grevianceDetails?.materialCode : null)
            }
        },
        {
            field: 'raisedOnDate', headerName: 'Grievance Date', width: 120,
            renderCell: (params) => {
                return (fDate(params?.value, 'dd/MM/yyyy'))
            }
        },
        { field: 'grievanceCategory', headerName: 'Grievance Category', width: 180 },
        { field: 'grievanceSubCategory', headerName: 'Grievance Sub-category', width: 180 },
        { field: 'emailId', headerName: 'Email Id', width: 150 },
        { field: 'mobile', headerName: 'Mobile', width: 150 },
        { field: 'firstName', headerName: 'Grievance Raised By', width: 150 }
    ]
    return (
        <>
            <Helmet>
                <title> Inspection Work Order </title>
            </Helmet>
            <Container maxWidth="xl">
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={8}>
                        <Typography variant="h4">
                            <Fab onClick={() => { navigate(`../inspectionworkorder/`) }} size="small" aria-label="back" title='Back'>
                                <KeyboardArrowLeftRounded />
                            </Fab>  Inspection Work Order
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={4} display="flex" flexWrap="wrap" justifyContent="flex-end">
                        <Button onClick={() => { navigate(`createNewInspectionOrder`) }} variant="contained" startIcon={<AddIcon />}>
                            Create New Inspection Order
                        </Button>
                    </Grid>
                </Grid>
                <Card sx={{ mt: 2 }}>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="select-used-equipment-label"> Select Type</InputLabel>
                                    <Select
                                        labelId="select-used-equipment-label"
                                        id="select-used-equipment"
                                        label="Select Type"
                                        name="type"
                                        value={details?.type}
                                        onChange={handleChange}>
                                        <MenuItem><em>Select</em></MenuItem>
                                        <MenuItem value="Issue">Issue</MenuItem>
                                        <MenuItem value="Grievance">Grievance</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {
                                showIssueUrn &&
                                <Grid item xs={12} lg={3}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="select-issue-urn-label"> Select URN</InputLabel>
                                        <Select
                                            labelId="select-issue-urn-label"
                                            id="select-issue-urn"
                                            label="Select URN"
                                            name="selectedURN"
                                            value={details?.selectedURN}
                                            onChange={handleChange}>
                                            <MenuItem><em>Select</em></MenuItem>
                                            {
                                                Array.from(new Set(allissuedetails?.filter(itemcheck => (itemcheck?.status == "Rejected") || ((itemcheck?.inspectionWorkOrderId == null) && (itemcheck?.status == "Open")))?.map(item => item?.measurementLocation)))?.map(value => {
                                                    return <MenuItem value={value}>{value}</MenuItem>
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item xs={12} lg={12}>
                                {(allissuedetails?.length > 0) && (details.type === 'Issue') &&
                                    <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                                        <DataGrid
                                            rows={allissuedetails?.filter(item => (item?.status == "Rejected") || ((item?.inspectionWorkOrderId == null) && (item?.status == "Open")) && (item?.measurementLocation == details?.selectedURN) && item.pitNoInspOrdFlag == true)}
                                            columns={issueColumns}
                                            pageSize={5}
                                            rowsPerPageOptions={[5]}
                                            getRowId={(row) => row?.issueNumber}
                                            checkboxSelection
                                            onSelectionModelChange={(e) => onClickChecked(e)}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    </Box>}
                                {(details?.type === 'Grievance') && (allGrievanceDetails?.length > 0) &&
                                    <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                                        <DataGrid
                                            rows={allGrievanceDetails}
                                            columns={grievanceColumns}
                                            pageSize={5}
                                            rowsPerPageOptions={[5]}
                                            getRowId={(row) => row?.ticketNumber}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    </Box>}
                            </Grid>
                            &nbsp;
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%', mt: 2 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Date of Inspection"
                                            inputFormat="DD/MM/YYYY"
                                            disablePast
                                            value={datevalue}
                                            onChange={(e) => { handleDateChange(e) }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ width: 750 }}
                                        /></LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%', mt: 2 }}>
                                    <InputLabel id="select-inspector-list-label">Inspector</InputLabel>
                                    <Select
                                        labelId="select-inspector-list-label"
                                        id="select-inspector"
                                        label="Inspector"
                                        name="inspectorName"
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        {
                                            inspectorDetails?.map((inspectorlist) =>
                                                <MenuItem value={inspectorlist?.firstname + '*' + inspectorlist?.emailAddress + '*' + inspectorlist?.mobileNo}>{inspectorlist?.firstname}</MenuItem>
                                            )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%', mt: 2 }} error={submit && !details.surpriseString}>
                                    <InputLabel id="select-check-surprise-label">Surprise</InputLabel>
                                    <Select
                                        labelId="select-check-surprise-label"
                                        id="select-check-surprise-equipment"
                                        label="Surprise"
                                        name="surpriseString"
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem><em>Select</em></MenuItem>
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </Select>
                                    <FormHelperText>{errorMessage?.errSurprise}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={4} mt={2}>
                                <FormControl sx={{ width: '100%' }} error={submit && (multiselectEquipment?.length < 1)}>
                                    <InputLabel id="select-used-equipment-label">Equipment to be Used</InputLabel>
                                    <Select
                                        labelId="select-used-equipment-label"
                                        id="select-used-equipment"
                                        label="Equipment to be Used"
                                        name="equipmentdetails"
                                        multiple
                                        value={multiselectEquipment}
                                        onChange={handleMultiEquipment}
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} />
                                                ))}
                                            </Box>
                                        )}
                                        MenuProps={MenuProps}
                                        sx={{ minWidth: 150 }}>
                                        <MenuItem>
                                            <em>Select</em>
                                        </MenuItem>
                                        {
                                            allequipmentdetails?.Inspection_equipment?.map((equipdetails) =>
                                                <MenuItem value={equipdetails}>{equipdetails}</MenuItem>
                                            )}
                                    </Select>
                                    <FormHelperText>{errorMessage?.errequipmentused}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={9} mt={2} >
                                <FormControl sx={{ width: '100%' }} error={submit && !details.inspectDescription}>
                                    <TextField fullWidth
                                        autoComplete="off"
                                        label="Description"
                                        inputProps={{
                                            maxLength: openTextFieldMaxLength
                                        }}
                                        multiline
                                        color="info"
                                        rows={5}
                                        value={details?.inspectDescription || ''}
                                        name='inspectDescription'
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <FormHelperText>{errorMessage?.errdescription}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={12} mt={2}>
                                <Box display='flex' alignItems="center" justifyContent="center">
                                    <Button endIcon={<SubmitIcon />} sx={{ minWidth: 120 }} variant="contained" onClick={(e) => finalSubmit(e)}>Submit</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
        </>
    )
}

export default AddInspectionPage